import React from 'react';
import styles from './unpay-liked-item.module.scss';
import { Avatar, Typography } from '@/ui-kit';
import { HeartIcon } from '@/assets/icons';
import { UnpayedLike } from '@/types/profile';
import { useAuth } from '@/store/useAuth';
import clsx from 'clsx';
import { getDisplayLikeCreatedDate, getUnPayLikeTitleMsg } from '@/utils/msgs';
import { useTranslation } from 'react-i18next';

interface Props {
    img?: string | null;
    like: UnpayedLike;
}

export const UnpayLikedItem: React.FC<Props> = ({ like }) => {
    const userData = useAuth((state) => state.getUser());

    const title = getUnPayLikeTitleMsg(
        userData?.gender,
        like?.profile?.gender
    )

    const likeProfileGnder =
        like?.profile?.gender

    const { t } = useTranslation();

    const subtitle =
        t('likes.liked_at', { context: likeProfileGnder, at: getDisplayLikeCreatedDate(like.created_at) })

    return (
        <div className={styles.wrapper}>
            {(
                <>
                    <div className={styles.avatar}>
                        <div className={styles.blurImageWrapper}>
                            <div className={
                                    clsx(
                                        !like
                                            .profile
                                            .is_paid &&
                                        styles
                                            .blurImage
                                    )
                                }>
                                <div className={styles.image}>
                                    <Avatar
                                        size={64}
                                        src={like?.profile?.photos?.length ? like?.profile?.photos[0]?.thumb_url : null}
                                        alt={t('likes.photo')}
                                        borderRadius="26px" />
                                </div>

                                {
                                    !like
                                        .profile
                                        .is_paid &&
                                    <HeartIcon
                                        width={24}
                                        height={24}
                                        className={styles.heart} />
                                }
                            </div>
                        </div>
                        {like?.profile?.is_online && <span className={styles.status}></span>}
                    </div>
                    <div className={styles.wrapInfo}>
                        <div className={styles.info}>
                            {
                                title.length ?
                                    <Typography typeColor="black" className={styles.name}>
                                        {
                                            title
                                        }
                                    </Typography>
                                :
                                    <></>
                            }
                            <Typography typeColor="gray" className={styles.time}>
                                {
                                    subtitle
                                }
                            </Typography>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
